var map = {
	"./ic_add.svg": 19210,
	"./ic_add_cart.svg": 11164,
	"./ic_add_cart_circle_blue.svg": 44684,
	"./ic_address_blue.svg": 44719,
	"./ic_arrow_blue.svg": 14807,
	"./ic_arrow_down_blue.svg": 89690,
	"./ic_arrow_down_gray.svg": 57804,
	"./ic_arrow_down_white.svg": 86128,
	"./ic_arrow_next_blue.svg": 88613,
	"./ic_arrow_prev_blue.svg": 3306,
	"./ic_arrow_prev_gray.svg": 52114,
	"./ic_arrow_radius.svg": 25551,
	"./ic_bacteria.svg": 59713,
	"./ic_box.svg": 36061,
	"./ic_button_add.svg": 79226,
	"./ic_calendar_days.svg": 8959,
	"./ic_caret_back.svg": 7630,
	"./ic_caret_forward.svg": 6704,
	"./ic_cart_black.svg": 87689,
	"./ic_cart_gray.svg": 41835,
	"./ic_cart_light_blue.svg": 96452,
	"./ic_category.svg": 51731,
	"./ic_chevron.svg": 63554,
	"./ic_chevron_next_blue.svg": 13363,
	"./ic_chevron_next_gray.svg": 23012,
	"./ic_chevron_prev_blue.svg": 92156,
	"./ic_chevron_prev_gray.svg": 74160,
	"./ic_circle_checked_green.svg": 13366,
	"./ic_circle_error_red.svg": 10970,
	"./ic_clock_blue.svg": 93064,
	"./ic_clock_light_blue.svg": 62257,
	"./ic_clock_pink.svg": 37255,
	"./ic_clock_white.svg": 49888,
	"./ic_close_black.svg": 68287,
	"./ic_close_circle.svg": 66263,
	"./ic_close_gray.svg": 43403,
	"./ic_close_white.svg": 84951,
	"./ic_collection.svg": 94805,
	"./ic_color.svg": 96841,
	"./ic_comment.svg": 8213,
	"./ic_customer_service.svg": 90468,
	"./ic_discipline.svg": 32073,
	"./ic_discount_gray.svg": 29027,
	"./ic_discount_light_blue.svg": 94917,
	"./ic_dress.svg": 83924,
	"./ic_edit.svg": 223,
	"./ic_elasticity.svg": 56013,
	"./ic_email_white.svg": 71910,
	"./ic_exchange.svg": 21248,
	"./ic_eye_pink.svg": 19419,
	"./ic_fabric.svg": 65287,
	"./ic_facebook_blue.svg": 93997,
	"./ic_facebook_white.svg": 7786,
	"./ic_family_love.svg": 52575,
	"./ic_fanpage_white.svg": 66823,
	"./ic_faq.svg": 32621,
	"./ic_fiber.svg": 70181,
	"./ic_file_blue.svg": 31212,
	"./ic_filter_blue.svg": 6378,
	"./ic_fire_work.svg": 65653,
	"./ic_flash_sale.svg": 80906,
	"./ic_flash_sale_2.svg": 61838,
	"./ic_free_delivery.svg": 28121,
	"./ic_google.svg": 28849,
	"./ic_hamburger_black.svg": 62774,
	"./ic_hamburger_white.svg": 2355,
	"./ic_heart_black.svg": 81883,
	"./ic_heart_blue.svg": 21854,
	"./ic_heart_white.svg": 58565,
	"./ic_hide_password.svg": 40685,
	"./ic_history.svg": 2218,
	"./ic_home_gray.svg": 84013,
	"./ic_home_light_blue.svg": 67678,
	"./ic_image.svg": 49286,
	"./ic_info.svg": 34349,
	"./ic_input_range.svg": 29515,
	"./ic_instagram_white.svg": 60477,
	"./ic_like.svg": 13088,
	"./ic_loading.svg": 83601,
	"./ic_location.svg": 32308,
	"./ic_location_search_white.svg": 67685,
	"./ic_location_white.svg": 63327,
	"./ic_logout.svg": 94530,
	"./ic_love.svg": 87367,
	"./ic_love_red.svg": 71124,
	"./ic_love_white.svg": 23718,
	"./ic_marker_yellow.svg": 32522,
	"./ic_menu_gray.svg": 78836,
	"./ic_menu_light_blue.svg": 34867,
	"./ic_messenger_white.svg": 36612,
	"./ic_next_black.svg": 26088,
	"./ic_next_blue.svg": 64408,
	"./ic_next_white.svg": 62744,
	"./ic_next_white_45deg.svg": 25341,
	"./ic_next_white_blue.svg": 1704,
	"./ic_pencil.svg": 67210,
	"./ic_phone_blue.svg": 7574,
	"./ic_phone_fill_blue.svg": 62495,
	"./ic_phone_light_blue.svg": 47448,
	"./ic_phone_white.svg": 79429,
	"./ic_play_blue.svg": 54973,
	"./ic_plus_gray.svg": 83507,
	"./ic_pray.svg": 73452,
	"./ic_prev_black.svg": 83721,
	"./ic_prev_blue.svg": 69621,
	"./ic_prev_white.svg": 77675,
	"./ic_price.svg": 92464,
	"./ic_remark_comment.svg": 5628,
	"./ic_research.svg": 5132,
	"./ic_right_arrow.svg": 24170,
	"./ic_salary.svg": 90309,
	"./ic_search.svg": 68049,
	"./ic_search_black.svg": 19693,
	"./ic_search_white.svg": 34592,
	"./ic_send_white.svg": 61987,
	"./ic_shirt.svg": 37060,
	"./ic_shorts.svg": 1596,
	"./ic_size.svg": 59450,
	"./ic_star_blue.svg": 79127,
	"./ic_star_orange.svg": 38138,
	"./ic_star_out_line.svg": 92337,
	"./ic_subtract_gray.svg": 43221,
	"./ic_teamwork.svg": 8374,
	"./ic_textile.svg": 32138,
	"./ic_tick.svg": 22565,
	"./ic_tiktok_white.svg": 21617,
	"./ic_time.svg": 79364,
	"./ic_time_blue.svg": 48012,
	"./ic_time_mobile.svg": 93287,
	"./ic_triangle_warning_yellow.svg": 2999,
	"./ic_trousers.svg": 22416,
	"./ic_tshirt.svg": 98442,
	"./ic_undo.svg": 33758,
	"./ic_upload.svg": 56600,
	"./ic_user.svg": 4197,
	"./ic_user_account_blue.svg": 95427,
	"./ic_user_black.svg": 34857,
	"./ic_user_gray.svg": 39453,
	"./ic_user_light_blue.svg": 32305,
	"./ic_view.svg": 92242,
	"./ic_view_password.svg": 57762,
	"./ic_vip.svg": 58006,
	"./ic_voucher.svg": 84263,
	"./ic_warning.svg": 85277,
	"./ic_website_white.svg": 35949,
	"./ic_wedding-dress.svg": 51046,
	"./ic_wish_list.svg": 79000,
	"./ic_zalo_white.svg": 57135
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65559;